import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import {
    Body1,
    Button,
    Heading1,
    Stack,
    useDisableBackButton,
} from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../../graphql/client/helpers/get-fragment';
import { PrescriberOrderStatus } from '../../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

import { useSwitchPrescription } from './shared';
import { SwitchTargetHeader } from './SwitchTargetHeader';

export const SwitchConfirmationPage = () => {
    const { t } = useTranslation();
    const { order, orderId, switchTarget } = useSwitchPrescription();

    useDisableBackButton(true);

    const providerPhoneNumber = getFragment(order.prescriber).phoneNumber;

    if (order.status !== PrescriberOrderStatus.OnHold) {
        return (
            <Navigate
                replace
                to={getAbsoluteRoute('order.prescriberOrderId.details', {
                    prescriberOrderId: orderId,
                })}
            />
        );
    }

    if (!switchTarget) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return (
        <Stack>
            <Heading1>{t('switchConfirmationPage.heading')}</Heading1>
            <SwitchTargetHeader option={switchTarget} />

            <Stack gap="xs">
                {switchTarget.confirmation.map((line) => (
                    <Body1 key={line}>
                        <span dangerouslySetInnerHTML={{ __html: line }} />
                    </Body1>
                ))}
            </Stack>

            <ConditionalComponent
                condition={Boolean(providerPhoneNumber?.length)}
            >
                <Button link to={`tel:${providerPhoneNumber}`} size="lg">
                    {t('switchConfirmationPage.callProvider')}
                </Button>
            </ConditionalComponent>

            <Button
                link
                to={getAbsoluteRoute('order.prescriberOrderId.details', {
                    prescriberOrderId: orderId,
                })}
                variant="outline"
                size="lg"
            >
                {t('switchConfirmationPage.returnToPrescription')}
            </Button>
        </Stack>
    );
};
